import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import bg from "../../assets/fnb-background.jpg";
import '../../styles/HeroSection.css';
import note from '../../assets/note.png';

import { Button } from 'react-day-picker';


const downloadPDF = () => {
  const link = document.createElement("a");
  link.href = "/Diagnostic-Guide.pdf";   // your file path
  link.download = "Diagnostic-Guide.pdf"; // file name for user
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};



const HeroSection = () => {
  const [active, setActive] = useState(false);
  return (
    <section id="diagnostic-content">
    <section className="hero-section" style={{
      backgroundImage: `url(${bg})`
    }}>
      <div className="hero-container">
        
        <div className="hero-badge shine-text">Operating Intelligence for Food & Beverage Businesses</div>

        <h1 className="hero-title2">
          FNBDATALAB embeds into your business and builds the systems 
            that protect your margins, stabilise your teams, and make growth sustainable.
          
        </h1>

        <div className="hero-statements">
          <div className="statement-item4"><b> We don't advise restaurants — we run operations beside them.</b></div>
          {/* <div className="statement-item">Most restaurants don't struggle because founders lack effort. They struggle when operations rely on improvisation instead of structure.</div>
          <div className="statement-item"><span className='highlight'>We don't advise restaurants — we run operations beside them.<br/>
                    FNBDATALAB embeds into your business and builds the systems that protect your margins, stabilise your teams, and make growth sustainable.</span></div>
          <div className="statement-item"><b> No slide decks. No theory. Just systems that make your business run better</b></div>
          {/* <div className="statement-item">FNBDATALAB brings structure, visibility, and execution discipline — so your business runs predictably, not reactively.</div> */}
        </div> 
        
        <div className="valu-card">
            
          {/* <p className="diagnostic-intro"> */}
            <b>
          We work with operators who are serious about structure. If you want quick fixes, we are not your firm</b>
          {/* </p> */}
          
          </div>


        {/* <p className="hero-description">
          FNBDATALAB is an operating intelligence partner for restaurants, cloud kitchens, cafés, QSRs, and multi-outlet F&B brands 
          — combining systems, data, and on-ground execution under one accountable framework.
        </p> */}
      <div className="hero-cta-group">
        <div>
          

<button
      className={`btn-5 ${active ? "active" : ""}`}
      onClick={() => {
        setActive(true);
        setTimeout(() => {
          window.location.href = "/operationals-diagnostic";
        }, 1200);
      }}
    >
      <div className="outline"></div>

      {/* DEFAULT */}
      <div className="state state--default">
        <div className="icon">START WITH OUR DIAGNOSTIC GUIDE</div>

        <p>
          {"START WITH OUR DIAGNOSTIC GUIDE".split("").map((char, i) => (
            <span key={i} style={{ "--i": i }}>
              {char === " " ? "\u00A0" : char}
            </span>
          ))}
        </p>
      </div>

      {/* SENT */}
      <div className="state state--sent">
        <div className="icon">✓</div>

        <p>
          {"STARTED".split("").map((char, i) => (
            <span key={i} style={{ "--i": i + 5 }}>
              {char}
            </span>
          ))}
        </p>
      </div>
    </button>
          {/* <Link to="#how-wework" className="btn-secondary">
          See How Our Operating Partnership Works
        </Link> */}
          {/* <button className="btn-secondary" onClick={downloadPDF}>
  ↓ Download Our Diagnostic Guide
</button> */}
        </div>



        
        

<div className="download-btn" onClick={downloadPDF}>
  <span className="btn-text">↓ Download Our Diagnostic Guide</span>

  <span className="btn-icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 24 24"
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 15V3m0 12l-4-4m4 4l4-4M2 17l.621 2.485A2 2 0 0 0 4.561 21h14.878a2 2 0 0 0 1.94-1.515L22 17"
      />
    </svg>
  </span>
</div>
        {/* <div className="cta-image-row">
          <a href="about#founder-note" className="image-button">
            <img
              src={note}   // import your image
              alt="A Note from the Founder"
            />
          </a>
        </div> */}
        </div>
      </div>
    </section>
    </section>
  );
};

export default HeroSection;